// utils/designVersion.js
import { setCookie, getCookie } from './cookies';

const DESIGN_VERSION_COOKIE_KEY = 'design_version';
const COOKIE_EXPIRY_DAYS = 30;

export function saveDesignVersion(version) {
    if (version) {
        setCookie(DESIGN_VERSION_COOKIE_KEY, version.toString(), COOKIE_EXPIRY_DAYS);
    }
}

export function getDesignVersion() {
    const version = getCookie(DESIGN_VERSION_COOKIE_KEY);
    return version ? parseInt(version, 10) : 2; // Default to version 2
}